import gql from 'graphql-tag';

const query = gql`
  query Tests($filter: HashimotoTestFieldEnum) {
    hashimoto {
      hashimotoTestHistory(hashimotoTestField: $filter) {
        edges {
          node {
            tsh
            ft3
            ft4
            antiTpo
            testedAt
            __typename
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
          __typename
        }
      }
    }
  }
`;

export default query;
